export enum PolicyGridEvents {
  OnNewGridItemAdd = 'onNewGridItemAdd',
  OnDeleteGridItem = 'onDeleteGridItem',
  MoveToTop = 'moveToTop',
  OnBasicEditRow = 'onBasicEditRow',
  OnEnableGridItem = 'onEnableGridItem',
  OnDisableGridItem = 'onDisableGridItem',
  OnCloneRow = 'onCloneRow',
}

export class OnNewGridItemAdd<T> extends CustomEvent<T> {
  constructor(value: T) {
    super(PolicyGridEvents.OnNewGridItemAdd, {
      detail: value,
      bubbles: true,
      composed: true,
    });
  }
}
